export const UI_updateSideDrawerOpenReducer = {
  UI_updateSideDrawerOpen: (state, action) => {
    state.isSideDrawerOpen = action.payload;
  },
};
